import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_CIVILBUDGETDETAIL,
  DELETE_CIVILBUDGETDETAIL,
  UPDATE_CIVILBUDGETDETAIL,
  ADD_NEW_CIVILBUDGETDETAIL,
} from "./actionType";

import {
  getCivilBudgetDetailSuccess,
  getCivilBudgetDetailFail,
  deleteCivilBudgetDetailSuccess,
  deleteCivilBudgetDetailFail,
  updateCivilBudgetDetailSuccess,
  updateCivilBudgetDetailFail,
  addCivilBudgetDetailSuccess,
  addCivilBudgetDetailFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getCivilBudgetDetailApi,
  updateCivilBudgetDetailApi,
  deleteCivilBudgetDetailApi,
  addNewCivilBudgetDetailApi,
  approveCivilBudgetDetailApi
} from "../../helpers/backend_helper";

function* getCivilBudgetDetail({ payload: civilBudgetDetail }) {
  try {
    const response = yield call(getCivilBudgetDetailApi, civilBudgetDetail);
    yield put(getCivilBudgetDetailSuccess(GET_CIVILBUDGETDETAIL, response.data));
  } catch (error) {
    yield put(getCivilBudgetDetailFail(GET_CIVILBUDGETDETAIL, error));
  }
}

function* onUpdateCivilBudgetDetail({ payload: civilBudgetDetail }) {
  try {
    if (civilBudgetDetail.setApprove) {
      const response = yield call(approveCivilBudgetDetailApi, civilBudgetDetail);
      yield put(updateCivilBudgetDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateCivilBudgetDetailApi, civilBudgetDetail);
      yield put(updateCivilBudgetDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateCivilBudgetDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteCivilBudgetDetail({ payload: civilBudgetDetail }) {
  try {
    const response = yield call(deleteCivilBudgetDetailApi, civilBudgetDetail);
    yield put(deleteCivilBudgetDetailSuccess({ civilBudgetDetail, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteCivilBudgetDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewCivilBudgetDetail({ payload: civilBudgetDetail }) {
  try {
    const response = yield call(addNewCivilBudgetDetailApi, civilBudgetDetail);
    yield put(addCivilBudgetDetailSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addCivilBudgetDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetCivilBudgetDetail() {
  yield takeEvery(GET_CIVILBUDGETDETAIL, getCivilBudgetDetail);
}

export function* watchUpdateCivilBudgetDetail() {
  yield takeEvery(UPDATE_CIVILBUDGETDETAIL, onUpdateCivilBudgetDetail);
}

export function* watchDeleteCivilBudgetDetail() {
  yield takeEvery(DELETE_CIVILBUDGETDETAIL, onDeleteCivilBudgetDetail);
}

export function* watchAddNewCivilBudgetDetail() {
  yield takeEvery(ADD_NEW_CIVILBUDGETDETAIL, onAddNewCivilBudgetDetail);
}

function* civilBudgetDetailSaga() {
  yield all([
    fork(watchGetCivilBudgetDetail),
    fork(watchDeleteCivilBudgetDetail),
    fork(watchUpdateCivilBudgetDetail),
    fork(watchAddNewCivilBudgetDetail)
  ]);
}

export default civilBudgetDetailSaga;
